import React, { useState, useEffect } from "react";
import { Box, Typography, Alert, Paper } from "@mui/material";
import { useSubscription } from "@apollo/client";
import { MigrationBasicInfo } from "./MigrationBasicInfo";
import { MigrationActions } from "./MigrationActions";
import { MigrationLogs } from "./MigrationLogs";
import { MigrationUpdatedSubscription } from "@/admin/entities/migrations";
import type { Migration } from "@/admin/entities/migrations";
import type { MigrationShowQueryQueryType } from "@/types/graphql/admin.generated";

interface MigrationDetailsProps {
  editData?: unknown;
  migration?: Migration;
}

export const MigrationDetails: React.FC<MigrationDetailsProps> = ({
  migration: migrationProp,
  editData,
}) => {
  const typedEditData = editData as MigrationShowQueryQueryType | undefined;
  const initialMigration = migrationProp || typedEditData?.migration;

  const [migration, setMigration] = useState<Migration | undefined>(
    initialMigration
  );

  const { data: subscriptionData, error: subscriptionError } = useSubscription(
    MigrationUpdatedSubscription,
    {
      variables: { id: migration?.id || "" },
      skip: !migration?.id,
    }
  );

  useEffect(() => {
    if (subscriptionData?.migrationUpdated) {
      setMigration(subscriptionData.migrationUpdated);
    }
  }, [subscriptionData]);

  useEffect(() => {
    if (initialMigration) {
      setMigration(initialMigration);
    }
  }, [initialMigration]);

  if (!migration) {
    return (
      <Paper sx={{ p: 2 }}>
        <Typography variant="h6" color="error">
          Миграция не найдена
        </Typography>
      </Paper>
    );
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {subscriptionError && (
        <Alert severity="warning">
          Ошибка подключения к обновлениям: {subscriptionError.message}
        </Alert>
      )}

      <MigrationBasicInfo migration={migration} />
      <MigrationActions migration={migration} />
      {migration.id && <MigrationLogs migrationId={migration.id} />}
    </Box>
  );
};
